import { fetchApi } from '@/config/axiosSetting.ts';
import { MoveToInprogressActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/moveToInprogressAction/moveToInprogressActionMutationFn.types';

export const moveToInprogressActionMutationFn = (
  data: MoveToInprogressActionMutationDataType,
  id: string,
) => fetchApi.post(`actions/${id}/move_to_in_progress/`, data);
